module.exports = __webpack_public_path__ + "static/media/5-STAR_logo_fullname.5eb7fa3e.png";